import { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { api } from '../lib/api';
import { Ghost, CheckCircle2 } from 'lucide-react';

export default function BookingSuccess() {
  const loc = useLocation();
  const [status, setStatus] = useState('Checking your payment...');
  const [paid, setPaid] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(loc.search);
    const sid = params.get('session_id');
    if (!sid) { setStatus('No session ID.'); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      if (attempts > 8) { setStatus('Still processing — check your email.'); return; }
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === 'paid') { setPaid(true); setStatus('Quest paid! Matching in progress.'); return; }
        if (r.data.status === 'expired') { setStatus('Session expired.'); return; }
        setStatus('Payment is being processed...');
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, [loc.search]);

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-20 text-center">
      <div className="float-anim inline-block">
        <Ghost size={64} className="text-[#f97316] mx-auto mb-4"/>
      </div>
      {paid ? (
        <>
          <CheckCircle2 size={28} className="text-[#f97316] mx-auto mb-3"/>
          <h1 className="text-4xl font-heading font-semibold mb-3">Booking received 🎉</h1>
          <p className="text-[#a3a3a3] mb-8">We're matching you with the right local. You'll get an email shortly. Chat unlocks once your host is confirmed.</p>
          <Link to="/dashboard" className="btn-primary" data-testid="success-dashboard">See my booking</Link>
        </>
      ) : (
        <>
          <h1 className="text-3xl font-heading font-semibold mb-3">{status}</h1>
          <p className="text-[#a3a3a3] text-sm">This page polls Stripe for confirmation.</p>
        </>
      )}
    </div>
  );
}
